'use strict';

/** After reload(), browsers often restore scroll; skip that when switching nav tabs. */
const NAV_TAB_SCROLL_TOP_KEY = 'lavNavTabScrollTop';

(function restoreNavTabScrollTop() {
	if (!sessionStorage.getItem(NAV_TAB_SCROLL_TOP_KEY)) return;
	sessionStorage.removeItem(NAV_TAB_SCROLL_TOP_KEY);
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}
	let scrollTop = function scrollTop() {
		window.scrollTo(0, 0);
	};
	scrollTop();
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', scrollTop);
	}
	window.addEventListener('load', scrollTop);
})();

const getCookie = name => {
	const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
	return match ? match[2] : null;
};

const setCookie = (name, value) => {
	document.cookie = name + '=' + value + ';path=/';
};

$(() => {
	// A page forced into one area (e.g. the PDP of a business-only product) aligns the cookie,
	// so the rest of the navigation stays in that area.
	const forcedArea = $('.page').data('pageArea');
	if (forcedArea && getCookie('selectedTab') !== forcedArea) {
		setCookie('selectedTab', forcedArea);
	}

	function handleNavTabActivate($tab, e) {
		if ($tab.hasClass('active')) return;

		if (e) {
			e.preventDefault();
		}
		setCookie('selectedTab', $tab.data('category'));
		let href = $tab.data('url') || $tab.attr('href') || $tab.find('a').attr('href');
		if (href) {
			sessionStorage.setItem(NAV_TAB_SCROLL_TOP_KEY, '1');
			window.location.assign(href);
			return;
		}
		window.location.reload();
	}

	$(document).on('click', '.header-nav-tab-item[data-category]', function onNavTabClick(e) {
		handleNavTabActivate($(this), e);
	});

	$(document).on('keydown', '.header-nav-tab-item[data-category]', function onNavTabKeydown(e) {
		if (e.key !== 'Enter' && e.key !== ' ') return;
		handleNavTabActivate($(this), e);
	});

	$(document).on('click', 'a.logo-home', function onLogoHomeClick() {
		setCookie('selectedTab', 'home');
	});
});
